export default __webpack_public_path__ + "images/7L.381fea8.png";